import { QTD_DEPENDENTES_ENUM } from '../../helpers/funcoesPadroes';

export const IDADE_ENUM = {
    sessentaQuatro: 64,
    sessentaCinco: 64
};

const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '03': 'IRMA(O)',
    '07': 'SOBRINHO(A)',
    '10006': 'ENTEADO(A)',
    '10016': 'OUTROS',
    '12': 'NETO(A)',
    '22': 'PRIMO(A)',
    '19': 'GENRO',
    '20': 'NORA',
    '24': 'TIO(A)',
    'AVô': 'AVO'
};

export const parentescosComRegrasEspeciais = [
    '01', //pai
    '20008', //padrasto

    '02', //mae
    '20007',  //madrasta

    '10', //esposo
    '32' //ex conjuge
];

export const parentescosSemValorAdicionalObrigatorioEmCasosEspeciais = [
    '01',
    '02',
    '10'
];

export const parentescosComAdicionalElegivel = [
    '20008',
    '20007',
    '32'
];

export const parentescosPermitidos = [
    '01',
    '02',
    '5',
    '10',
    '15',
    '32',
    '10',
    '10002',
    '10003',
    '20008',
    '20007'
];

export const grausEquivalentes = {
    '01': '20008',
    '20008': '01',

    '02': '20007',
    '20007': '02',

    '10': '32',
    '32': '10'
};

const verificarSemAdicional = categoria => categoria?.trim() !== 'ZELO';

export const validatorDependenteComValorAdicional = valoresForm => {
    const arrayDeValidacoes = [
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorAte65AnosComAdicioanal = valoresForm => {
    const arrayDeValidacoes = [
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaAdicionalAte65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaior65AnosComAdicional = valoresForm => {
    const arrayDeValidacoes = [
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarCategoriaAdicionalAcima65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm = ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24', '32'];

    if (!parentesco) {
        return false;
    }

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        return false;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

export const validarLimiteCategoria = (dependentes, categoria, limit) => {
    const dependentesFiltrados = dependentes.filter(dependente => {
        const categoriaDep = dependente.Categoria || dependente['CategoriaParentesco.Categoria'];

        return categoriaDep === categoria;
    }).length;

    return dependentesFiltrados < limit;
};

export const validarCategoria = (dependentes, categoria) => {
    const categoriaFiltro = categoria.trim() === 'ZSM65' ? 'ZSA64' : 'ZSM65';

    const dependenteCategoria = dependentes.filter(dependente => {
        const categoria = dependente.Categoria || dependente['CategoriaParentesco.Categoria'];

        return categoria === categoriaFiltro;
    }).length;

    return !dependenteCategoria;
};

export const validarExisteDoisDependAcima65Anos = (dependents, idadeDigitada, idadeAssociado) => {
    const dependentesComMais65Anos = dependents.filter(dependent => dependent.Idade > IDADE_ENUM.sessentaQuatro);
    const qtdDependenteMaximo65Anos = idadeAssociado > IDADE_ENUM.sessentaQuatro ? QTD_DEPENDENTES_ENUM.um : QTD_DEPENDENTES_ENUM.dois;

    if (idadeDigitada > IDADE_ENUM.sessentaQuatro && dependentesComMais65Anos.length >= qtdDependenteMaximo65Anos) { return true; }

    return false;
};

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = categoria => categoria !== '';
const verificarParentescoPrenchido = parentesco => parentesco !== '';

const verificarCategoriaAdicionalAte65 = categoria => categoria.trim() !== 'ZSA64';
const verificarCategoriaAdicionalAcima65 = categoria => categoria.trim() !== 'ZSM65';

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'AVô') {
        return `Só é permitido quatro dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]}`;
};

export const validarExisteDoisDependAcima65AnosEdicao = (dependents, idadeDigitada, idadeAssociado, idEdicao) => {
    const dependentesComMais65Anos = dependents.filter(dependent => dependent.Idade > IDADE_ENUM.sessentaQuatro);

    // Filtrar fora o dependente que está sendo editado, se ele estiver na lista dos maiores de 65 anos.
    const dependentesComMais65AnosExcluindoEdicao = dependentesComMais65Anos.filter(dependent => dependent.Seq !== idEdicao);

    const qtdDependenteMaximo65Anos = idadeAssociado > IDADE_ENUM.sessentaQuatro ? QTD_DEPENDENTES_ENUM.um : QTD_DEPENDENTES_ENUM.dois;

    if (idadeDigitada > IDADE_ENUM.sessentaQuatro && dependentesComMais65AnosExcluindoEdicao.length >= qtdDependenteMaximo65Anos) {
        return true;
    }

    return false;
};

export const validarLimiteCategoriaEdicao = dependentes => {
    const dependentesFiltrados = dependentes.filter(dependente => {
        const categoria = dependente.Categoria || dependente['CategoriaParentesco.Categoria'];

        return categoria === 'ZSA64' || categoria === 'ZSM65';
    }).length;

    return dependentesFiltrados;
};

const verificarParentescosComRegrasEspeciais = parentesco => {
    const parentescoEncontrado = parentescosComRegrasEspeciais.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado ? true : false;
};

const verificarParentescoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidos.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? true : false;
};

export const validatorDependenteSemValorAdicional = valoresForm => {
    const arrayDeValidacoes = [
        (verificarParentescoPermitido(valoresForm?.Parentesco) && !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco)),
        verificarIdadePreenchida(valoresForm?.Idade),
        verificarCategoriaPrenchida(valoresForm?.Categoria),
        verificarParentescoPrenchido(valoresForm?.Parentesco),
        verificarSemAdicional(valoresForm?.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const comparaRegrasDepAtuaisComDepUpSell = (dependentes, idadeAssociado) => {
    const contagemCategoraExistente = {
        ZELO: 0,
        OUTRASCATEGORIAS: 0,
        ACIMA65: 0
    };

    const limitCategoriaZELO = 9;
    const limitCategoriaDiferenteZelo = QTD_DEPENDENTES_ENUM.um;
    const limiteMaximoAcima65 = idadeAssociado > IDADE_ENUM.sessentaCinco ? QTD_DEPENDENTES_ENUM.um : QTD_DEPENDENTES_ENUM.dois;

    for (const dep of dependentes) {
        const categoria = dep.Categoria;
        const idadeDependente = dep['Idade'];
        const seq = dep.Seq;

        if (categoria === 'ZELO') {
            contagemCategoraExistente.ZELO++;
        } else if ((categoria === 'ZSA64' || categoria === 'ZSM65')) {
            if (contagemCategoraExistente.ZELO < limitCategoriaZELO) {
                return `Dependente na posição ${seq} com categoria ${categoria} encontrado antes da posição permitida.`;
            } else {
                contagemCategoraExistente.OUTRASCATEGORIAS++;
            }
        } else {
            return `A categoria do dependente na seq: ${seq} esta icorreta para este plano.`;
        }

        if (idadeDependente > IDADE_ENUM.sessentaCinco) {
            contagemCategoraExistente.ACIMA65++;
        }
    }

    if (contagemCategoraExistente.ZELO > limitCategoriaZELO) {
        return `Limite de dependentes ZELO excedido. Limite permitido: ${limitCategoriaZELO}; encontrado: ${contagemCategoraExistente.ZELO}.`;
    }

    if (contagemCategoraExistente.OUTRASCATEGORIAS > limitCategoriaDiferenteZelo) {
        return `Limite de dependentes especial excedido. Limite permitido: ${limitCategoriaDiferenteZelo}, encontrado: ${contagemCategoraExistente.OUTRASCATEGORIAS}.`;
    }

    if (contagemCategoraExistente.ACIMA65 > limiteMaximoAcima65) {
        return `Limite de dependentes acima de 64 anos excedido, é permitido até ${limiteMaximoAcima65} dependente e foram encontrado: ${contagemCategoraExistente.ACIMA65}.`;
    }
};
